module.exports = __webpack_public_path__ + "static/footer-horizontal-09e6c87fe722200267a0cf464841fb6f.jpg";